export enum OpenGraphPropertyEnum {
  URL = 'og:url',
  TYPE = 'og:type',
  TITLE = 'og:title',
  DESCRIPTION = 'og:description',
  IMAGE = 'og:image',
}
